import { Input } from 'antd';
import { useEffect, useState } from 'react';

interface Props {
  onChange?: () => void;
  type?: string;
  refresh?: boolean;
  onSearchName?: any;
}
const SearchBox = ({ onChange, type, refresh, onSearchName }: any) => {
  const { Search } = Input;
  const onSearch = (value: string) => console.log(value);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!!refresh) {
      setValue('');
    }
  }, [refresh]);

  return (
    <div className="search_inquery">
      {type === true ? (
        <Search
          className="search_input-seller"
          placeholder="검색"
          // allowClear
          value={value}
          onSearch={onSearch}
          onChange={(e: any) => {
            onChange(e);
            setValue(e.target.value);
          }}
        />
      ) : (
        <Search
          className="search_input"
          placeholder="Search"
          allowClear
          value={value}
          onSearch={onSearch}
          onChange={(e: any) => {
            onChange(e);
            setValue(e.target.value);
          }}
        />
      )}
    </div>
  );
};

export default SearchBox;
